import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

import Loadable from 'components/Loadable';
import ProtectedRoute from 'components/ProtectedRoute';
import DashboardLayout from 'layout/Dashboard';
import Loader from 'components/Loader';
import { useAuth } from 'contexts/AuthContext';

const OperariosPage = Loadable(lazy(() => import('pages/operarios')));
const OperarioDetailPage = Loadable(lazy(() => import('pages/operarios/detalle')));

const OPERARIOS_ROLES = new Set(['admin', 'supervisor', 'produccion']);

const OperariosLayoutGuard = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return <Loader />;
  }

  const normalizedRole = (user?.role || '').toString().trim().toLowerCase();
  if (!OPERARIOS_ROLES.has(normalizedRole)) {
    return <Navigate to="/areas" replace />;
  }

  return (
    <ProtectedRoute>
      <DashboardLayout />
    </ProtectedRoute>
  );
};

const OperariosRoutes = {
  path: '/operarios',
  element: <OperariosLayoutGuard />,
  children: [
    {
      index: true,
      element: <OperariosPage />
    },
    {
      path: ':userId',
      element: <OperarioDetailPage />
    },
    {
      path: 'dashboard',
      children: [
        {
          index: true,
          element: <Navigate to="/operarios" replace />
        },
        {
          path: 'default',
          element: <Navigate to="/operarios" replace />
        }
      ]
    }
  ]
};

export default OperariosRoutes;
